export const ME = 'ME';
export const MY_MENUS = 'MY_MENUS';

export default {
  ME,
  MY_MENUS,
};
